export default "__VITE_ASSET__DAfjGBl4__"